import lang from './lang';

export default {
  lang
};
